export default {
  abandonProduct: 'Abandon Product',
  abandonProductTips:
    'Friendly reminder: When you confirm [Abandon Product], we will destroy your product and it cannot be recovered. The product will not be returned to the seller for a refund. Please proceed with caution.',
  finePhotos: 'Detailed photography',
  ordinaryPhotos: 'Ordinary picture',
  expireText: 'The package is about to expire',
  more: 'More',
  timeExpand: 'Extended Duration',
  guaranteeService: 'Guarantee Service',
  noNeed: "Don't need",
  'i18n-0000002':
    'Your item has exceeded the storage period. We will keep it for an additional 28 days. After this period, it will be deemed abandoned and disposed of accordingly.',
  'i18n-0000003':
    'If you need to extend the storage period, please purchase the value-added service for extended storage within 28 days.',
  'i18n-0000004': 'Storage expiration time',
  'i18n-0000016': 'Product storage has expired',
  'i18n-0000019': 'Storage extension unpaid. Item considered voluntarily abandoned.',
  'i18n-0000023': 'Completed',
  refundTip: 'After confirmation, the storage fee will be refunded to your account.',
  storageEnum: {
    1: 'Warehouse 1, China',
    2: 'Warehouse 2, China',
  },
  'i18n-00001':
    'I agree that acbuy can modify the declared information to meet the requirements of the local CUSTOMS and improve the CUSTOMS clearance rate. If no insurance is purchased, I shall bear the CUSTOMS clearance responsibilities and consequences arising therefrom.',
  'i18n-00002':
    'I do not agree modification. Please declare according to the original information, and I shall bear the CUSTOMS clearance responsibilities and consequences arising therefrom.',
  'i18n-00003': 'Agree to the modification',
  'i18n-00004': 'Disagree to the modification',
  'i18n-00005': 'Reported information modification',
  'i18n-00006':
    'Each declaration information content must be greater than 25 characters. Please adjust and resubmit',
  'i18n-00007':
    'Based on higher of actual/volumetric weight. Any difference will be refunded or charged within 72 hours after packaging',
  'i18n-00008':
    'Each piece of declared information must be less than {length} characters. Please adjust and resubmit.',
  'i18n-00009':
    '{AI} still has unpaid value-added services. To keep them, please complete the payment and wait for the service to finish before submitting the parcel. If you choose to submit the parcel now, the system will automatically cancel the corresponding value-added services that remain unpaid.',
}
